import axios from "axios";

import baseDomain, { addFaqTagApi } from "../../Constants/apiRoutes";

export const createFaqTag = (data) => {
  return axios.post(`${baseDomain}${addFaqTagApi}`, data);
};
